import { ca } from '@cian/analytics';

import { PinService } from 'shared/services/PinService';
import { PIN_EXTENDED_TYPES, PIN_TYPES } from 'shared/utils/mapModules/PinsLayer/types';

const paramsMap = ['active', 'favorite', 'viewed'];

const prepareLabel = (pinService: PinService): string => {
  const extendedTypes = pinService.provideExtendedTypes();
  const pinType = pinService.provideType();
  const isActive = extendedTypes.has(PIN_EXTENDED_TYPES.active);
  const isFavorite = extendedTypes.has(PIN_EXTENDED_TYPES.favorite);
  const isViewed = extendedTypes.has(PIN_EXTENDED_TYPES.viewed);

  const pinColor = pinType === PIN_TYPES.regular ? 'blue' : 'white';

  const pinParams = [isActive, isFavorite, isViewed].reduce<string[]>((acc, extendedType, ind) => {
    if (extendedType) {
      acc.push(paramsMap[ind]);
    }

    return acc;
  }, []);

  if (!pinParams.length) {
    const basePinParam = 'usual';

    pinParams.push(basePinParam);
  }

  return `${pinColor}/${pinParams.join('/')}`;
};

export function trackMapPinClick(pinService: PinService): void {
  ca('eventSite', {
    action: 'Click_pin',
    category: 'Map',
    label: prepareLabel(pinService),
    name: 'oldevent',
  });
}
